import { motion } from "framer-motion"; // For modal entrance animations
import CustomButton from "../../components/v2/custom-button/CustomButton";
import { Box, Typography } from "@mui/material";
import HtmlContent from "../../components/html-content/HtmlContent";
import SparkleIllustration from "../../assets/images/celebration-images/celeb_sparkles.png";
import LockedImage from "../../assets/images/celebration-images/celeb_locked.png";
import UnlockedImage from "../../assets/images/celebration-images/celeb_unlocked.png";
import { useEffect, useState } from "react";
import { Celebrations } from "../../utility/interfaces/carePlanInterfaces";
import { getCelebrationImage } from "./CelebrationCommon";
import { useTranslation } from "react-i18next";
import { useAppSelector } from "../../store/hooks";

interface TierUnlockedProps {
  onClose: (celebration: Celebrations) => void;
  celebration: Celebrations;
}

export const TierUnlocked: React.FC<TierUnlockedProps> = ({
  onClose,
  celebration,
}) => {
  const [showUnlock, setShowUnlock] = useState(false);
  const [showTierBadge, setShowTierBadge] = useState(false);
  const { t } = useTranslation();
  const preferredLanguage = useAppSelector(
    (state) => state.patientOnboardingStatus.preferredLanguage
  );
  useEffect(() => {
    setTimeout(() => setShowUnlock(true), 1500); // Show unlock icon
    setTimeout(() => setShowTierBadge(true), 2000); // Show badge + sparkles
  }, []);

  return (
    <motion.div
      className={`modal modal--tier ${celebration?.eventCode}_main `}
      initial={{ opacity: 0, scale: 0.8 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ duration: 0.6 }}
    >
      <div
        className={`modal__tier-visual-wrapper ${celebration?.eventCode}_subMain`}
      >
        {!showUnlock && (
          <img src={LockedImage} alt="Locked" className="modal__lock-image" />
        )}
        {showUnlock && !showTierBadge && (
          <img
            src={UnlockedImage}
            alt="Unlocked"
            className="modal__unlock-image"
          />
        )}
        {showTierBadge && (
          <>
            <motion.img
              src={getCelebrationImage(
                celebration?.eventCode,
                preferredLanguage.toLowerCase()
              )}
              alt="Tier Badge"
              className={`modal__tier-image  ${celebration?.eventCode}`}
              initial={{ scale: 1, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              transition={{ duration: 0.6 }}
            />
            {[...Array(6)].map((_, i) => (
              <img
                key={i}
                src={SparkleIllustration}
                alt="Sparkle"
                className={`sparkle sparkle--${i + 1}`}
              />
            ))}
          </>
        )}
      </div>

      <Typography variant="body1" mb={3} className="celebration">
        <HtmlContent htmlString={celebration.content || "NA"} />
      </Typography>

      <Box>
        <CustomButton
          onClick={() => onClose(celebration)}
          variant="contained"
          text={t("noShowAppointment.closeButton")}
        />
      </Box>
    </motion.div>
  );
};
